var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 19,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.925.503a2.25 2.25 0 0 1 1.94 1.11L14.679 3h2.071A3.25 3.25 0 0 1 20 6.25v9.5A3.25 3.25 0 0 1 16.75 19H3.25A3.25 3.25 0 0 1 0 15.75v-9.5A3.25 3.25 0 0 1 3.25 3h2.08l.875-1.424A2.25 2.25 0 0 1 8.122.503h3.803ZM10 6a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 1.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
  fill: "#9CA3AA"
})));
export default SvgIcCamera;